var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.22,
    y: 8,
    width: 5.109,
    height: 10.055,
    rx: 0.5,
    transform: "rotate(135 15.22 8)",
    fill: "currentColor",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.11,
    y: 15.11,
    width: 5.109,
    height: 10.055,
    rx: 0.5,
    transform: "rotate(-135 8.11 15.11)",
    fill: "currentColor",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.22,
    y: 8,
    width: 10.055,
    height: 10.055,
    rx: 0.5,
    transform: "rotate(135 15.22 8)",
    stroke: "currentColor"
  })));
}
export default SvgParentTheme;